import React, {Component} from 'react';
import {withStyles} from 'material-ui/styles';
import BigCalendar from 'react-big-calendar'
import moment from 'moment'
import 'react-big-calendar/lib/css/react-big-calendar.css';
import CalendarHeader from 'main/content/apps/calendar/CalendarHeader';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import * as Actions from './store/actions';
import {
    TextField, Button, Dialog, DialogActions, DialogContent, MenuItem, FormControl, InputLabel, Input, Icon, IconButton, Typography, Toolbar, AppBar, FormControlLabel, Switch
} from 'material-ui';
import EventDialog from 'main/content/apps/calendar/EventDialog';
import {DragDropContext} from 'react-dnd'
import HTML5Backend from 'react-dnd-html5-backend'
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop'
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';
import axios from 'axios';
import CloseIcon from '@material-ui/icons/Close';
import Formsy from 'formsy-react';
import { TextFieldFormsy, SelectFormsy, CheckboxFormsy, FuseCountdown } from '@fuse';
import { withAlert } from 'react-alert';

BigCalendar.setLocalizer(BigCalendar.momentLocalizer(moment));

const DragAndDropCalendar = withDragAndDrop(BigCalendar);

let allViews = Object.keys(BigCalendar.Views).map(k => BigCalendar.Views[k]);

const styles = theme => ({
    root     : {
        display                                                                                                        : 'flex',
        position                                                                                                       : 'relative',
        flexDirection                                                                                                  : 'column',
        flex                                                                                                           : 1,
        '& .rbc-header'                                                                                                : {
            padding   : '12px 6px',
            fontWeight: 500,
            fontSize  : 14
        },
        '& .rbc-label'                                                                                                 : {
            padding: '8px 6px'
        },
        '& .rbc-today'                                                                                                 : {
            backgroundColor: 'transparent'
        },
        '& .rbc-header.rbc-today, & .rbc-month-view .rbc-day-bg.rbc-today'                                             : {
            borderBottom: '2px solid ' + theme.palette.secondary.main + '!important'
        },
        '& .rbc-month-view, & .rbc-time-view, & .rbc-agenda-view'                                                      : {
            padding: 24,
            ...theme.mixins.border(0)
        },
        '& .rbc-agenda-view table'                                                                                     : {
            ...theme.mixins.border(1),
            '& thead > tr > th': {
                ...theme.mixins.borderBottom(0)
            },
            '& tbody > tr > td': {
                padding : '12px 6px',
                '& + td': {
                    ...theme.mixins.borderLeft(1)
                }
            }
        },
        '& .rbc-time-view'                                                                                             : {
            '& .rbc-time-header' : {
                ...theme.mixins.border(1)
            },
            '& .rbc-time-content': {
                flex: '0 1 auto',
                ...theme.mixins.border(1)
            }
        },
        '& .rbc-month-view'                                                                                            : {
            '& > .rbc-row'               : {
                ...theme.mixins.border(1)
            },
            '& .rbc-month-row'           : {
                ...theme.mixins.border(1),
                borderWidth: '0 1px 1px 1px!important',
                minHeight  : 128
            },
            '& .rbc-header + .rbc-header': {
                ...theme.mixins.borderLeft(1)
            },
            '& .rbc-header'              : {
                ...theme.mixins.borderBottom(0)
            },
            '& .rbc-day-bg + .rbc-day-bg': {
                ...theme.mixins.borderLeft(1)
            }
        },
        '& .rbc-day-slot .rbc-time-slot'                                                                               : {
            ...theme.mixins.borderTop(1),
            opacity: 0.5
        },
        '& .rbc-time-header > .rbc-row > * + *'                                                                        : {
            ...theme.mixins.borderLeft(1)
        },
        '& .rbc-time-content > * + * > *'                                                                              : {
            ...theme.mixins.borderLeft(1)
        },
        '& .rbc-day-bg + .rbc-day-bg'                                                                                  : {
            ...theme.mixins.borderLeft(1)
        },
        '& .rbc-time-header > .rbc-row:first-child'                                                                    : {
            ...theme.mixins.borderBottom(1)
        },
        '& .rbc-timeslot-group'                                                                                        : {
            minHeight: 64,
            ...theme.mixins.borderBottom(1)
        },
        '& .rbc-date-cell'                                                                                             : {
            padding   : 8,
            fontSize  : 16,
            fontWeight: 400,
            opacity   : .5,
            '& > a'   : {
                color: 'inherit'
            }
        },
        '& .rbc-event'                                                                                                 : {
            borderRadius            : 0,
            padding                 : '4px 8px',
            backgroundColor         : theme.palette.primary.dark,
            color                   : theme.palette.primary.contrastText,
            boxShadow               : theme.shadows[0],
            transitionProperty      : 'box-shadow',
            transitionDuration      : theme.transitions.duration.short,
            transitionTimingFunction: theme.transitions.easing.easeInOut,
            position                : 'relative',
            '&:hover'               : {
                boxShadow: theme.shadows[2]
            }
        },
        '& .rbc-row-segment'                                                                                           : {
            padding: '0 4px 4px 4px'
        },
        '& .rbc-off-range-bg'                                                                                          : {
            backgroundColor: theme.palette.type === 'light' ? 'rgba(0,0,0,0.03)' : 'rgba(0,0,0,0.16)'
        },
        '& .rbc-show-more'                                                                                             : {
            color     : theme.palette.secondary.main,
            background: 'transparent'
        },
        '& .rbc-addons-dnd .rbc-addons-dnd-resizable-month-event'                                                      : {
            position: 'static'
        },
        '& .rbc-addons-dnd .rbc-addons-dnd-resizable-month-event .rbc-addons-dnd-resize-month-event-anchor:first-child': {
            left  : 0,
            top   : 0,
            bottom: 0,
            height: 'auto'
        },
        '& .rbc-addons-dnd .rbc-addons-dnd-resizable-month-event .rbc-addons-dnd-resize-month-event-anchor:last-child' : {
            right : 0,
            top   : 0,
            bottom: 0,
            height: 'auto'
        }
    },
    addButton: {
        position: 'absolute',
        right   : 12,
        top     : 172,
        zIndex  : 99
    }
});

class CalendarApp extends Component {

    constructor(props) {
        super(props);
        
        this.state = {
            tasks: [],
            openComposeDialog: false,
            title: "",
            deadLine: "",
            itemName: "",
            comment: "",
            status: "Pending",
            idRegistry: 0,
            idTask: 0,
            idSubtask: 0,
            idSubtaskAssign: 0,
            companyName: "-"
        };

        this.openNewEventDialog = this.openNewEventDialog.bind(this);
        this.closeNewEventDialog = this.closeNewEventDialog.bind(this);
        this.updateTask = this.updateTask.bind(this);
        this.getTasks = this.getTasks.bind(this);
    }

    componentWillMount()
    {
        this.getTasks();
    }

    getTasks(){

        // axios.post('http://localhost:5003/job/tasks/byId', {'userId':this.props.user.employeeId})
        axios.post(window.crmServer+'/job/tasks/byId',{'userId':this.props.user.latestEmployeeId ? this.props.user.latestEmployeeId : 0})
        .then(response => {

            console.log(response.data);
            var data = [];

            for(var i = 0; response.data.length>i; i++){


                data.push({
                    allDay:true,
                    id:response.data[i].ID_SUBTASK_ASSIGN,
                    title:response.data[i].SUB_TASK_CODE+"("+response.data[i].SUBTASK_ASSIGN_TYPE+")",
                    start:new Date(response.data[i].SUBTASK_ASSIGN_DATE),
                    end:new Date(response.data[i].SUBTASK_ASSIGN_DATE),
                    SUB_TASK_CODE:response.data[i].SUB_TASK_CODE,
                    EXPECTED_DATE:response.data[i].EXPECTED_DATE,
                    REMARK:response.data[i].TASK_REMARK,
                    COMMENT:response.data[i].COMMENT,
                    SUB_TASK_INSTRUMENT:response.data[i].SUB_TASK_INSTRUMENT,
                    SUBTASK_ASSIGN_STATUS:response.data[i].SUBTASK_ASSIGN_STATUS,
                    ID_JOB_REGISTRY:response.data[i].ID_JOB_REGISTRY,
                    ID_JOB_TASK:response.data[i].ID_JOB_TASK,
                    ID_JOB_SUB_TASK:response.data[i].ID_JOB_SUB_TASK,
                    ID_SUBTASK_ASSIGN:response.data[i].ID_SUBTASK_ASSIGN,
                    COMPANY_NAME:response.data[i].cx_company || "-",
                })
            }

            this.setState({ tasks:data });
            console.log(this.state.tasks);
        });

    }

    moveEvent = ({event, start, end}) => {
        this.props.updateEvent({
            ...event,
            start,
            end
        });
    };

    resizeEvent = (resizeType, {event, start, end}) => {
        delete event.type;
        this.props.updateEvent({
            ...event,
            start,
            end
        });
    };

openNewEventDialog(data)
{

    console.log(data);

    this.setState({title:data.SUB_TASK_CODE});
    this.setState({deadLine:(data.EXPECTED_DATE).substring(0, 10)});
    this.setState({remark:data.REMARK});
    this.setState({comment:data.COMMENT});
    this.setState({itemName:data.SUB_TASK_INSTRUMENT});
    this.setState({status:data.SUBTASK_ASSIGN_STATUS});
    this.setState({idRegistry:data.ID_JOB_REGISTRY});
    this.setState({idTask:data.ID_JOB_TASK});
    this.setState({idSubtask:data.ID_JOB_SUB_TASK});
    this.setState({idSubtaskAssign:data.ID_SUBTASK_ASSIGN});
    this.setState({openComposeDialog:true});
    this.setState({companyName:data.COMPANY_NAME});
}

closeNewEventDialog()
{
    this.setState({openComposeDialog:false});
}

updateTask(data){

    if(this.state.status == data.status && this.state.comment == data.comment){

        this.props.alert.error("Nothing to Update");
    }

    else{

    // axios.post('http://localhost:5003/job/updateTask',data)
        axios.post(window.crmServer+'/job/updateTask',data)
        .then(response => {
            if(response.data.status){

            this.getTasks();
            this.setState({openComposeDialog:false});
            this.props.alert.success(response.data.msg);
            }
            else{

                this.setState({openComposeDialog:false});
                this.props.alert.error(response.data.msg);
            }
        });
    }
}

    render()
    {
        const {classes, events, openNewEventDialog, openEditEventDialog} = this.props;

        return (
            <div className={classes.root}>
                <DragAndDropCalendar
                    selectable
                    onEventDrop={this.moveEvent}
                    resizable
                    onEventResize={this.resizeEvent}
                    className="flex flex-1"
                    events={this.state.tasks}
                    views={allViews}
                    step={60}
                    showMultiDayTimes
                    defaultDate={new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())}
                    components={{
                        toolbar: CalendarHeader
                    }}
                    // onNavigate={this.handleNavigate}
                    onSelectEvent={event => {
                        this.openNewEventDialog(event);
                    }}
                    // onSelectSlot={slotInfo => openNewEventDialog({
                    //     start: slotInfo.start.toLocaleString(),
                    //     end  : slotInfo.end.toLocaleString()
                    // })}
                />
                {/* <Button
                    variant="fab"
                    color="secondary"
                    aria-label="add"
                    className={classes.addButton}
                    onClick={() => openNewEventDialog({
                        start: new Date(),
                        end  : new Date()
                    })}
                >
                    <Icon>add</Icon>
                </Button> */}

                {/* <EventDialog/> */}
                <Dialog className={classes.root} open={this.state.openComposeDialog} fullWidth maxWidth="xs">
                <Formsy
                            onValidSubmit={this.updateTask}
                            onValid={this.enableButton}
                            onInvalid={this.disableButton}
                            ref={(form) => this.form = form}
                            className=""
                        >
                <AppBar className="app-bar-size" position="static">
                    <Toolbar className="justify-between pl-16">
                        <Typography variant="subheading" color="inherit">
                           Task Details
                        </Typography>
                        <IconButton className="" color="inherit" onClick={this.closeNewEventDialog} aria-label="Close">
                                    <CloseIcon />
                                </IconButton>
                    </Toolbar>
                </AppBar>

                <DialogContent className="p-24">

                        <TextFieldFormsy
                            className="w-full mt-12"
                            type="text"
                            name="task_code"
                            label="Task Ref. No"
                            value={this.state.title}
                            disabled
                        />

                        <TextFieldFormsy
                            className="w-full mt-12"
                            type="text"
                            name="company_name"
                            label="Company Name"
                            value={this.state.companyName}
                            disabled
                        />

                         <TextFieldFormsy
                            className="w-full mt-12"
                            type="text"
                            name="deadLine"
                            label="Dead Line"
                            value={this.state.deadLine}
                            disabled
                        />
                        {/* <FuseCountdown endDate={this.state.deadLine} className="my-48"/>                         */}

                         <TextFieldFormsy
                            className="w-full mt-12"
                            type="text"
                            name="instrument_name"
                            label="Instrument"
                            value={this.state.itemName}
                            disabled
                        />

                        <TextFieldFormsy
                            className="w-full mt-12"
                            label="Remark"
                            type="text"
                            name="Remark"
                            value={this.state.remark}
                            disabled
                        />

                        <TextFieldFormsy
                            className="w-full mt-12"
                            label="Comment"
                            type="text"
                            name="comment"
                            value={this.state.comment}
                        />

                         <SelectFormsy
                        className="w-full mt-12"
                        name="status"
                        label="Task Status"
                        value={this.state.status}
                        required
                    >
                        
                        <MenuItem key='1' value='Pending'>Pending</MenuItem>
                        <MenuItem key='2' value='In Progress'>In Progress</MenuItem>
                        <MenuItem key='3' value='Completed'>Completed</MenuItem>
                    </SelectFormsy>

                     <TextFieldFormsy
                            type="hidden"
                            name="id_job_registry"
                            value={this.state.idRegistry}
                            required
                        />
                        
                        <TextFieldFormsy
                            type="hidden"
                            name="id_job_task"
                            value={this.state.idTask}
                            required
                        />
                        
                        <TextFieldFormsy
                            type="hidden"
                            name="id_job_subtask"
                            value={this.state.idSubtask}
                            required
                        />
                        
                        <TextFieldFormsy
                            type="hidden"
                            name="id_job_subtask_assign"
                            value={this.state.idSubtaskAssign}
                            required
                        />
                        
                </DialogContent>

                 <DialogActions className="justify-right pl-16">
                        <Button
                        type="submit"
                            variant="raised"
                            color="primary"
                            // onClick={() => {
                            //     updateEvent(this.state);
                            //     this.closeComposeDialog();
                            // }}
                            // disabled={!this.canBeSubmitted()}
                        > Update
                        </Button>
                        {/* <IconButton
                            // onClick={() => {
                            //     removeEvent(this.state.id);
                            //     this.closeComposeDialog();
                            // }}
                        >
                            <Icon>delete</Icon>
                        </IconButton> */}
                    </DialogActions>
                    </Formsy>
            </Dialog>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch)
{
    return bindActionCreators({
        getEvents          : Actions.getEvents,
        openNewEventDialog : Actions.openNewEventDialog,
        openEditEventDialog: Actions.openEditEventDialog,
        updateEvent        : Actions.updateEvent
    }, dispatch);
}

// function mapStateToProps({calendarApp})
// {
//     return {
//         events: []
//     }
// }

function mapStateToProps({ fuse, auth }) {
    return {
        user: auth.user
    }
}

export default withStyles(styles, {withTheme: true})(connect(mapStateToProps, mapDispatchToProps)(DragDropContext(HTML5Backend)(withAlert(CalendarApp))));


// WEBPACK FOOTER //
// ./src/main/content/apps/calendar/CalendarApp.js